import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SynSplashScreenService } from './syn-splash-screen.service';

@Component({
  selector: 'syn-splash-screen',
  templateUrl: './syn-splash-screen.component.html',
  styleUrl: './syn-splash-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinnerModule],
})
export class SynSplashScreenComponent {
  protected isVisible = inject(SynSplashScreenService).isLoaderVisibleSignal;
}
